"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledLogo = exports.StyledMobileTopnav = exports.TopnavMain = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _StyledLayout = require("../../../../../StyledLayout");

var _Elements = require("../../../../Elements");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var TopnavMain = _styledComponents["default"].div.withConfig({
  displayName: "Elements__TopnavMain",
  componentId: "sc-1lvnsia-0"
})(["background:", ";z-index:2;position:relative;width:100%;padding:48px 48px 0 48px;box-sizing:border-box;opacity:0;transform:translate3d(0,-50px,0);transition:transform 500ms ease,opacity 500ms ease;", " &:hover{p{color:", ";}}"], function (props) {
  return props.theme.portfolioBackground1;
}, function (props) {
  return props.show && (0, _styledComponents.css)(["opacity:1;transform:translate3d(0,0,0);"]);
}, function (props) {
  return props.theme[props.colour];
});

exports.TopnavMain = TopnavMain;
var StyledMobileTopnav = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__StyledMobileTopnav",
  componentId: "sc-1lvnsia-1"
})(["width:100%;height:60px;position:fixed;top:0;z-index:3;background:", ";svg{path{fill:", ";}}"], function (props) {
  return props.theme.portfolioBackground1;
}, function (props) {
  return props.theme.portfolioForeground1;
});
exports.StyledMobileTopnav = StyledMobileTopnav;
var StyledLogo = (0, _styledComponents["default"])(_Elements.Logo).withConfig({
  displayName: "Elements__StyledLogo",
  componentId: "sc-1lvnsia-2"
})(["letter-spacing:0.03em"]);
exports.StyledLogo = StyledLogo;